import { render, staticRenderFns } from "./Clipboard.vue?vue&type=template&id=55538262&"
import script from "./Clipboard.vue?vue&type=script&lang=ts&"
export * from "./Clipboard.vue?vue&type=script&lang=ts&"
import style0 from "./Clipboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports